import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { EmployeeAuthGuard } from './guards/employee-auth.guard';
import { LogoutComponent } from './modules/profile/logout/logout.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [EmployeeAuthGuard],
        loadChildren: () => import('./tabs/tabs.module').then((m) => m.TabsPageModule),
    },
    {
        path: 'login',
        loadChildren: () =>
            import('./modules/login/login.module').then((m) => m.LoginPageModule),
    },
    {
        path: 'employeelogin',
        loadChildren: () =>
            import('./modules/employee-login/employee-login.module').then(
                (m) => m.EmployeeLoginModule
            ),
    },
    {
        path: 'logout',
        component: LogoutComponent,
    },
];
@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
